import { useEffect } from 'react'
import { navigate } from 'gatsby'

const About = () => {
  useEffect(() => navigate('team'))
  return null
}

export default About
